import { ButtonBase, Tooltip } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import WarningIcon from "@material-ui/icons/Warning";

// Mesma tolerância da V5: abaixo de 1% de variação é "Manter".
const LIMIAR_MANTER = 0.01;

// Mesmas cores dos selos da tela (Curva, Promo): verde sobe, vermelho baixa, cinza mantém.
const ESTILO = {
  baixar: { background: "#fce4ec", color: "#c62828", rotulo: "Baixar" },
  manter: { background: "#eeeeee", color: "#616161", rotulo: "Manter" },
  subir: { background: "#e8f5e9", color: "#2e7d32", rotulo: "Subir" }
};

export const direcaoDaVariacao = variacao => {
  if (variacao == null || !Number.isFinite(variacao)) return null;
  if (Math.abs(variacao) < LIMIAR_MANTER) return "manter";
  return variacao > 0 ? "subir" : "baixar";
};

export const textoDoSelo = (recomendacao, variacao) => {
  const estilo = ESTILO[recomendacao];
  if (!estilo) return "--";
  const { rotulo } = estilo;
  if (recomendacao === "manter" || variacao == null) return rotulo;
  const pct = Math.round(variacao * 100);
  // Percentual que arredonda para zero ou contradiz o rótulo não vai no selo.
  if (pct === 0 || (recomendacao === "baixar") !== pct < 0) return rotulo;
  return `${rotulo} ${pct < 0 ? "−" : "+"}${Math.abs(pct)}%`;
};

const SuggestionCell = ({
  recomendacao,
  variacao,
  preco,
  avisos = [],
  expanded,
  onToggle,
  rotuloAbrir = "Ver o porquê"
}) => {
  if (!recomendacao || !ESTILO[recomendacao])
    return <span style={{ color: "#757575" }}>--</span>;
  const { background, color } = ESTILO[recomendacao];

  const conteudo = (
    <span
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4
      }}
    >
      <span style={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
        <span
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: "rgba(0, 0, 0, 0.87)",
            fontVariantNumeric: "tabular-nums"
          }}
        >
          {preco}
        </span>
        {onToggle ? (
          <KeyboardArrowDownIcon
            style={{
              fontSize: 18,
              color: "#1976d2",
              transform: expanded ? "rotate(180deg)" : "none"
            }}
          />
        ) : null}
      </span>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
        <span
          style={{
            background,
            color,
            borderRadius: 4,
            padding: "2px 8px",
            fontSize: 11.5,
            fontWeight: 600,
            whiteSpace: "nowrap"
          }}
        >
          {textoDoSelo(recomendacao, variacao)}
        </span>
        {avisos.length ? (
          <Tooltip title={avisos.join(" · ")} arrow>
            <WarningIcon
              style={{ fontSize: 16, color: "#f57f17" }}
              aria-label={avisos.join(", ")}
            />
          </Tooltip>
        ) : null}
      </span>
    </span>
  );

  if (!onToggle) return conteudo;
  return (
    <ButtonBase
      onClick={onToggle}
      aria-label={rotuloAbrir}
      aria-expanded={Boolean(expanded)}
      style={{
        borderRadius: 4,
        padding: "5px 10px",
        background: expanded ? "#e3f2fd" : "transparent",
        border: `1px solid ${expanded ? "#90caf9" : "transparent"}`
      }}
    >
      {conteudo}
    </ButtonBase>
  );
};

export default SuggestionCell;
